import fetch from 'unfetch';
import ApolloClient from 'apollo-boost';

const client = new ApolloClient({
  uri: `${(BUILD_VARS && window.__POWERED_BY_QIANKUN__) ? BUILD_VARS.QUERY_DOMAIN : ''}/v1.0/graphql`,
  credentials: 'include',
  fetch,
});

export default client;
